import {CreditAccountSummaryModel} from '../../model/credit/credit-account-summary.model';
import {CreditLedgerEntryModel} from '../../model/credit/credit-ledger-entry.model';
import {Searchable} from '../../state/searchable-state';
import axios from '../axios';

export namespace CreditAccountController {
  export type QueryCreditLedgerRes = {
    total: number
    available: any
    items: CreditLedgerEntryModel[]
  }

  export const getCreditAccountSummary = async (organizationId: string) =>
    (await axios.get<CreditAccountSummaryModel>(`/internal/credit/accounts/${organizationId}`)).data

  export type TopUpReq = {
    hours: number
    invoiceNumber?: string | null
    comment?: string | null
  }

  export const topUpCreditAccount = async (organizationId: string, request: TopUpReq) =>
    (await axios.post(`/internal/credit/accounts/${organizationId}/top-up`, request))

  export const queryCreditLedger = async (organizationId: string, searchable: Searchable) =>
    (await axios.put<QueryCreditLedgerRes>(`/internal/credit/accounts/${organizationId}/ledger`, searchable)).data
}
